import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout';
import { AuthProvider } from '@/components/auth';
import { LoadingScreen, ErrorBoundary, ToastProvider } from '@/components/common';

// Lazy load route components for code-splitting
const HomePage = lazy(() => import('@/components/home/HomePage'));
const AgencyListPage = lazy(() => import('@/components/agencies/AgencyListPage'));
const AgencyDetailPage = lazy(() => import('@/components/agencies/AgencyDetailPage'));
const RatingFlowPage = lazy(() => import('@/components/rating/RatingFlowPage'));
const EvaluationPage = lazy(() => import('@/components/rating/EvaluationPage'));
const DashboardPage = lazy(() => import('@/components/dashboard/DashboardPage'));

/**
 * Route loading fallback with skeleton
 */
function RouteLoadingFallback(): JSX.Element {
  return <LoadingScreen message="Seite wird geladen..." />;
}

/**
 * App Root - wraps with AuthProvider for MSAL
 * AuthProvider handles showing LoginPage when not authenticated
 * Routes are lazy-loaded for better initial bundle size
 */
function App(): JSX.Element {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <Suspense fallback={<RouteLoadingFallback />}>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="agencies" element={<AgencyListPage />} />
                <Route path="agencies/:id" element={<AgencyDetailPage />} />
                <Route path="rating/:agencyId" element={<RatingFlowPage />} />
                <Route path="evaluate" element={<EvaluationPage />} />
                <Route path="dashboard" element={<DashboardPage />} />
              </Route>
            </Routes>
          </Suspense>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
